export default class ContactCustomerSupport {
  constructor() {
    this.selector = '.contact-customer-support .c-form-saleforce';

    this.selectors = {
      sourceForm: '.contact-support-form',
      modalAddFilesTarget: '.actions button[data-bs-target]',
      targetFormSessionIdField: 'input[name="TICKET.case_id"]',
      targetFormFileField: 'input[name="TICKET.hs_file_upload"]',
      targetFormEmailField: 'input[name="email"]',
      sourceFormEmailField: 'input[name="email"]',
      sourceFormSessionIdField: 'input[name="HubSpot_Document_ID__c"]',
      sourceFormFilesNumberField: 'input[name="Number_of_HubSpot_Files__c"]',
      targetEmailContainer: '.hs_email',
      formNotice: '.b-dev-zone-forms__form-notice',
      addFilesContainer: '.b-dev-zone-forms__form-add-files-btn',
    };

    this.classes = {
      formNoticeHidden: 'b-dev-zone-forms__form-notice--hidden',
      addFilesContainerHidden: 'b-dev-zone-forms__form-add-files-btn--hidden',
    };

    this.sessionId = Date.now() + Math.random().toString(36).slice(2, 15) + Math.random().toString(36).slice(2, 15);
  }

  getModal() {
    const buttonAddFiles = document.querySelector(this.selectors.modalAddFilesTarget);

    if (buttonAddFiles) {
      const { bsTarget } = buttonAddFiles.dataset;

      const modal = document.querySelector(bsTarget);

      if (modal) {
        return modal;
      }
    }
  }

  updateState() {
    const sourceForm = document.querySelector(this.selectors.sourceForm);

    if (!sourceForm) {
      return;
    }

    const sourceSessionId = sourceForm.querySelector(this.selectors.sourceFormSessionIdField);

    if (sourceSessionId) {
      sourceSessionId.value = this.sessionId;
    }

    const sourceEmail = sourceForm.querySelector(this.selectors.sourceFormEmailField);

    const modal = this.getModal();

    if (!modal) {
      return;
    }

    const emailContainer = modal.querySelector(this.selectors.targetEmailContainer);

    if (emailContainer) {
      emailContainer.style.display = 'none';
    }

    const targetSessionId = modal.querySelector(this.selectors.targetFormSessionIdField);

    if (targetSessionId) {
      targetSessionId.value = this.sessionId;
    }

    const targetEmail = modal.querySelector(this.selectors.targetFormEmailField);

    if (targetEmail) {
      targetEmail.value = sourceEmail.value;
    }
  }

  bootstrap() { // eslint-disable-line sonarjs/cognitive-complexity
    const pageForm = document.querySelector(this.selector);

    if (!pageForm) {
      return;
    }

    const sourceForm = document.querySelector(this.selectors.sourceForm);

    if (!sourceForm) {
      return;
    }

    const sourceEmail = sourceForm.querySelector(this.selectors.targetFormEmailField);

    sourceEmail.addEventListener('change', () => {
      this.updateState();
    });

    this.updateState();

    const buttonAddFiles = document.querySelector(this.selectors.modalAddFilesTarget);

    if (buttonAddFiles) {
      const { bsTarget } = buttonAddFiles.dataset;

      const modal = document.querySelector(bsTarget);

      if (modal) {
        const form = modal.querySelector('.c-form-hubspot');

        if (!form) {
          return;
        }

        const { formId } = form.dataset;

        window.addEventListener('message', event => {
          if (event.data.type !== 'hsFormCallback' || event.data.id !== formId) {
            return;
          }

          if (
            event.data.eventName === 'onFormReady'
          ) {
            this.updateState();

            const targetFormFileField = modal.querySelector(this.selectors.targetFormFileField);

            if (targetFormFileField) {
              targetFormFileField.addEventListener('change', () => {
                this.updateState();
              });
            }
          }

          if (
            event.data.eventName === 'onFormSubmit'
          ) {
            jQuery(modal).modal('hide');

            const files = event.data.data.find(
              item => item.name === 'TICKET.hs_file_upload'
            ).value || [];

            const sourceFormFilesNumber = sourceForm.querySelector(this.selectors.sourceFormFilesNumberField);

            const filesNumber = files.length;

            if (sourceFormFilesNumber) {
              sourceFormFilesNumber.value = filesNumber;
            }

            const formNotice = document.querySelector(this.selectors.formNotice);

            if (formNotice) {
              const { template } = formNotice.dataset;

              formNotice.innerHTML = `${filesNumber} ${template}`;
              formNotice.classList.remove(this.classes.formNoticeHidden);
            }

            const addFilesContainer = document.querySelector(this.selectors.addFilesContainer);

            if (addFilesContainer) {
              addFilesContainer.classList.add(this.classes.addFilesContainerHidden);
            }
          }
        });
      }
    }
  }
}
